import './polyfills'; // Import polyfills first
import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactModal from 'react-modal';
import { HelmetProvider } from 'react-helmet-async';
import 'rc-tabs/assets/index.css'; // Import rc-tabs styles directly
import './assets/css/modal.css'; // Import our new modal CSS
import './assets/css/drawer-fixes.css'; // Import drawer fixes CSS
import App from './pages/index.jsx'; // Update to reflect the renamed file extension
import PrivacyPage from './pages/privacy.jsx';
// import './index.css'; // We might need to create/adjust CSS imports later

// Set app element for accessibility
if (typeof window !== 'undefined' && document.getElementById('root')) {
  console.log('Setting app element for ReactModal');
  ReactModal.setAppElement('#root');
}

const pathname = typeof window !== 'undefined' ? window.location.pathname : '/';
const RootComponent = pathname === '/privacy' || pathname === '/privacy/' ? PrivacyPage : App;

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <RootComponent />
    </HelmetProvider>
  </React.StrictMode>
); 